import React, { useState, useEffect } from 'react';
import { socialLinks, logoUrl } from '../data/mock';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Etiquette', href: '#etiquette' },
    { label: 'Services', href: '#services' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'Apply', href: '#contact' }
  ];

  const scrollTo = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled
            ? 'bg-[#0a0908]/95 backdrop-blur-md py-3 shadow-lg'
            : 'bg-transparent py-4'
        }`}
      >
        <div className="container mx-auto px-6 flex items-center justify-between">
          {/* Logo */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="hover:opacity-80 transition-opacity duration-300"
          >
            <img 
              src={logoUrl} 
              alt="Mistress T-Rex Monroe" 
              className="h-20 md:h-28 lg:h-32 w-auto"
            />
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollTo(link.href)}
                className="text-[#A69080] text-sm tracking-[0.2em] uppercase hover:text-[#D4A853] transition-colors relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#D4A853] transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#D4A853] hover:text-[#8B7355] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-[#0a0908]/98 backdrop-blur-lg transition-all duration-500 md:hidden ${
          isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <nav className="h-full flex flex-col items-center justify-center gap-8">
          {/* Logo in mobile menu */}
          <img 
            src={logoUrl} 
            alt="Mistress T-Rex Monroe" 
            className="h-32 w-auto mb-6"
          />
          {navLinks.map((link, index) => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.href)}
              className={`text-[#A69080] text-xl tracking-[0.3em] uppercase hover:text-[#D4A853] transition-all duration-300 ${
                isMobileMenuOpen
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              {link.label}
            </button>
          ))}
          <div className="flex gap-6 mt-8">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#8B7355] text-sm tracking-widest uppercase hover:text-[#D4A853] transition-colors"
              >
                {social.name}
              </a>
            ))}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
